import { render } from "./TireSizeWheelWide.vue?vue&type=template&id=bdb9228e"
import script from "./TireSizeWheelWide.vue?vue&type=script&lang=js"
export * from "./TireSizeWheelWide.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TireSizeWheelWide.vue?vue&type=style&index=0&id=bdb9228e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__